import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 12.583 9.245",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.583 9.245\" id=\"icon-email\"><path d=\"M-84.776,24.934H-95.428a.971.971,0,0,0-.963.978v7.294a.97.97,0,0,0,.968.973h10.647a.97.97,0,0,0,.968-.973v-7.3A.971.971,0,0,0-84.776,24.934Zm-1.512.978L-90.1,29.446l-3.815-3.538Zm1.512,7.294H-95.423v-7.3h.08l4.585,4.254a.965.965,0,0,0,1.313,0l4.582-4.249h.086Z\" transform=\"translate(96.391 -24.934)\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol